import React, { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi";

const Faq = () => {
  const [accordionItems, setAccordionItems] = useState([
    {
      title: "How does ASTRAHACK simulate blockchain transactions?",
      content:
        "ASTRAHACK uses dummy transactions and interactive simulations to illustrate the process of transactions between miners, senders, and receivers, without implementing an actual blockchain.",
      isOpen: false,
    },
    {
      title: "Can I use ASTRAHACK to practice real cryptocurrency transactions?",
      content:
        "No, ASTRAHACK is designed for educational purposes only and does not support real cryptocurrency transactions.",
      isOpen: false,
    },
    {
      title: "Is ASTRAHACK suitable for beginners?",
      content:
        "Yes, ASTRAHACK caters to users of all skill levels, providing intuitive tools and educational resources to facilitate learning about blockchain technology.",
      isOpen: false,
    },
    {
      title: "Is ASTRAHACK accessible on mobile devices?",
      content:
        "Yes, ASTRAHACK is optimized for mobile use, allowing you to learn about blockchain transactions on the go. Simply access our platform through your smartphone or tablet browser for seamless learning anytime, anywhere.",
      isOpen: false,
    },
  ]);

  const toggleAccordion = (index) => {
    setAccordionItems((prev) =>
      prev.map((item, i) => ({
        ...item,
        isOpen: i === index ? !item.isOpen : false,
      }))
    );
  };

  return (
    <div id="faq" className="relative py-24">
      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16 space-y-4">
          <h4 className="text-primary font-bold tracking-wider uppercase text-sm">FAQ</h4>
          <h2 className="text-4xl md:text-5xl font-bold text-white">Questions & Answers</h2>
          <p className="text-text-muted max-w-2xl mx-auto text-lg">
            Got questions? We've got answers! Check out our FAQ section to find solutions to common
            queries about ASTRAHACK
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {accordionItems.map((item, index) => (
            <div
              key={index}
              className="glass-card rounded-xl overflow-hidden border border-white/5 transition-colors hover:border-white/10"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
              >
                <span
                  className={`text-lg font-semibold transition-colors ${item.isOpen ? "text-white" : "text-text-muted"}`}
                >
                  {item.title}
                </span>
                <span
                  className={`text-xl transition-transform duration-300 ${item.isOpen ? "rotate-180 text-primary" : "text-text-muted"}`}
                >
                  {item.isOpen ? <FiMinus /> : <FiPlus />}
                </span>
              </button>

              <div
                className={`grid transition-all duration-300 ease-in-out ${item.isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
              >
                <div className="overflow-hidden">
                  <div className="p-6 pt-0 text-text-muted leading-relaxed border-t border-white/5 mx-6 mt-2">
                    {item.content}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Faq;
